import { render } from "./GenererRedevancePage.vue?vue&type=template&id=b59f4cb6&ts=true"
import script from "./GenererRedevancePage.vue?vue&type=script&lang=ts"
export * from "./GenererRedevancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__